const cough = [

    {
    label:"Type of cough",
    controlType:"radio button",
    options:["Dry", "Productive"]
    },

    {
    label:"Frequency",
    controlType:"radio button",
    options:["Every day", "Most days", "Weekly", "Evey couple of weeks", "Monthly", "Occasionally"]
    },

    {
    label:"Present for several:",
    controlType:"radio button",
    options:["Days", "Weeks","Months","Years"]
    }


]

export default cough